/* COUNTRY HIGH — Newsletter -> Mailchimp (JSONP, ohne Backend/Secrets).
   Liest window.CH_MC_ACTION (Mailchimp Form-Action-URL aus Theme-Einstellungen).
   Übergibt Merge-Felder EMAIL, FNAME, LNAME, LANGUAGE, LEVEL, STYLE.
   Zeigt danach die vorhandene [data-ch-nl-done]-Ansicht. */
(function () {
  var ACTION = window.CH_MC_ACTION || '';
  // Mapping Website-Feldname -> Mailchimp-Parameter (nur saubere Merge-Felder).
  // Level/Stil sind in Mailchimp Interessengruppen mit anderen Optionen -> vorerst nicht gesendet.
  var MC_MERGE = { EMAIL: 'EMAIL', FNAME: 'FNAME', LNAME: 'LNAME', LANGUAGE: 'MMERGE5' };
  var LANG_CODE = { 'Deutsch': 'DE', 'English': 'EN', 'Englisch': 'EN', 'Français': 'FR', 'Francais': 'FR', 'Italiano': 'IT', 'Italienisch': 'IT', 'Español': 'ES', 'Espanol': 'ES', 'Spanisch': 'ES' };
  // Mailchimp-Tag-IDs (numerisch) fürs Segmenting — von der Newsletter-Sitzung geliefert.
  // Signup setzt: 1 Sprach-Tag + newsletter + signup_website. CH-Default DE, wenn Sprache unklar.
  var LANG_TAG = { DE: '4605258', EN: '4605309', IT: '4605255', FR: '4605257', ES: '4605502' };
  var TAG_NEWSLETTER = '4604924', TAG_SOURCE = '4605771';

  function jsonp(url, cb) {
    var name = 'chmc_' + Math.floor(performance.now()) + '_' + (jsonp._n = (jsonp._n || 0) + 1);
    var s = document.createElement('script');
    var done = false;
    window[name] = function (data) { done = true; cleanup(); cb(null, data); };
    function cleanup() { try { delete window[name]; } catch (e) { window[name] = undefined; } if (s.parentNode) s.parentNode.removeChild(s); }
    s.onerror = function () { if (!done) { cleanup(); cb(new Error('network')); } };
    s.src = url + (url.indexOf('?') > -1 ? '&' : '?') + 'c=' + name;
    document.body.appendChild(s);
    setTimeout(function () { if (!done) { cleanup(); cb(new Error('timeout')); } }, 8000);
  }

  function findDone(form) {
    var wrap = form.closest('[data-ch-nl-form-wrap]') || form.parentNode;
    return wrap ? wrap.querySelector('[data-ch-nl-done]') : null;
  }
  function showDone(form) {
    var done = findDone(form);
    if (done) { form.style.display = 'none'; done.style.display = 'block'; }
    else { showMsg(form, '♥ Willkommen in der Family — schau in dein Postfach!', true); }
  }
  function showMsg(form, text, ok) {
    var el = form.querySelector('[data-ch-nl-msg]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-ch-nl-msg', '');
      el.style.cssText = 'margin-top:12px;font-family:var(--font-read);font-size:14px;line-height:1.5;';
      form.appendChild(el);
    }
    el.style.color = ok ? 'var(--ch-ink)' : '#b5503d';
    el.innerHTML = text;
  }

  document.addEventListener('submit', function (ev) {
    var form = ev.target.closest && ev.target.closest('[data-ch-nl-form]');
    if (!form) return;
    ev.preventDefault();

    var emailEl = form.querySelector('[name="EMAIL"], input[type="email"]');
    var email = emailEl ? (emailEl.value || '').trim() : '';
    if (!email || email.indexOf('@') < 1) { showMsg(form, 'Bitte gib eine gültige E-Mail-Adresse ein.', false); if (emailEl) emailEl.focus(); return; }

    var consent = form.querySelector('input[type="checkbox"]');
    if (consent && !consent.checked) { showMsg(form, 'Bitte bestätige die Anmeldung mit dem Häkchen.', false); consent.focus(); return; }

    var btn = form.querySelector('button[type="submit"],button:not([type])');
    var btnTxt = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Wird gesendet…'; }
    function reset() { if (btn) { btn.disabled = false; btn.textContent = btnTxt; } }

    // Ohne konfigurierte Mailchimp-URL: UX nicht blockieren (Theme-Vorschau) — Danke-Ansicht zeigen.
    if (!ACTION) { reset(); showDone(form); return; }

    var params = [];
    Object.keys(MC_MERGE).forEach(function (fname) {
      var val;
      if (fname === 'EMAIL') { val = email; }
      else { var el = form.querySelector('[name="' + fname + '"]'); val = el ? (el.value || '').trim() : ''; }
      if (!val) return;
      if (fname === 'LANGUAGE') val = LANG_CODE[val] || val;
      params.push(MC_MERGE[fname] + '=' + encodeURIComponent(val));
    });
    // Sprach-/Quellen-Tags anhängen (Mailchimp list-manage akzeptiert komma-separierte Tag-IDs).
    var langEl = form.querySelector('[name="LANGUAGE"]');
    var langVal = langEl ? (langEl.value || '').trim() : '';
    var langCode = LANG_CODE[langVal] || 'DE';
    var langTag = LANG_TAG[langCode] || LANG_TAG.DE;
    var tagList = [langTag, TAG_NEWSLETTER, TAG_SOURCE];
    // Formular-spezifische Zusatz-Tags (z. B. DanceFever-Interesse nur auf der DF-Seite): data-ch-nl-tags="ID,ID".
    var extraTags = form.getAttribute('data-ch-nl-tags');
    if (extraTags && extraTags.trim()) tagList.push(extraTags.trim());
    params.push('tags=' + tagList.join(','));

    var base = ACTION.replace('/post?', '/post-json?');
    // f_id entfernen: Mailchimp verwirft mit spezifischer Form-ID die Merge-Felder (FNAME/LNAME/MMERGE5).
    base = base.replace(/([?&])f_id=[^&]*/g, '$1').replace(/[?&]+$/, '').replace(/&&+/g, '&').replace(/\?&/, '?');
    var url = base + (base.indexOf('?') > -1 ? '&' : '?') + params.join('&');

    jsonp(url, function (err, data) {
      reset();
      if (err) { showMsg(form, 'Ups, das hat nicht geklappt. Bitte später nochmal versuchen.', false); return; }
      if (data && data.result === 'success') { showDone(form); return; }
      var msg = (data && data.msg) ? String(data.msg).replace(/^[0-9]+\s*-\s*/, '') : 'Bitte prüfe deine Eingabe.';
      // "already subscribed" freundlich als Erfolg behandeln
      if (/already|bereits/i.test(msg)) { showDone(form); return; }
      showMsg(form, msg, false);
    });
  });

  // Consent-Häkchen: Submit-Button erst aktiv, wenn angehakt (technisch korrekt / DSGVO)
  function initConsent() {
    document.querySelectorAll('[data-ch-nl-form]').forEach(function (form) {
      var cb = form.querySelector('input[type="checkbox"]');
      var btn = form.querySelector('button[type="submit"],button:not([type])');
      if (!cb || !btn || cb._chWired) return;
      cb._chWired = true;
      function sync() { var ok = cb.checked; btn.disabled = !ok; btn.style.opacity = ok ? '' : '0.55'; btn.style.cursor = ok ? '' : 'not-allowed'; }
      cb.addEventListener('change', sync); sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initConsent); else initConsent();
})();
